import { FilterOptions } from '../../filter-options';
import orangeNewsCategories from './orangenews-categories.json';

export const orangeNewsOptions: FilterOptions[] = orangeNewsCategories.catgegories;
